
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Generelt',
	'widgetId': 'Widget-id',
	'widgetType': 'Elementtype',
	'serviceability': 'Kan serviceres',
	'copyButton': 'Kopiér',
	'closeButton': 'Luk',
	'specification': 'Specifikation',
	'viewSpecification': 'Vis specifikation'
});
